<template>
  <div class="case-detail-gene-user-setting-dailog dialog col-block">
    <div class="title-container row-block">
      <div
        class="title"
        v-html="{
          'db': 'Population Databases'/* ___ */,
          'ps': 'Prediction Scores'/* ___ */
        }[param.type]"
      ></div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div class="tab-container row-block">
      <div :style="{ flex: 1 }"></div>
      <div class="tab-block row-block" :class="{ display: display['dbSelect'] }" @click="e => display['dbSelect'] = !display['dbSelect']">
        <div :style="{ width: '16px' }"></div>
        <div class="tab-title">{{ 'Options'/* ___ */ }}</div>
        <div :style="{ width: '8px' }"></div>
        <img :src="require('../../assets/images/new-tab-display-icon.svg')" alt="">
        <div :style="{ width: '8px' }"></div>
      </div>
    </div>
    <hr class="no-margin">
    <div :style="{ height: '15px' }"></div>
    <template v-if="display['dbSelect']">
      <div v-if="afpCols" class="report-container col-block">
        <div class="report-group col-block" v-for="(reportGroups, rgindex) in reportOptionGroups" :key="rgindex">
          <div class="report-block col-block" :class="{ 'title-only': !(report.optionGroups || []).length }" v-for="(report, rindex) in reportGroups.filter(report => (report.display || (() => true))(variants))" :key="rindex">
            <div class="report-title-container row-block">
              <div class="report-title-block row-block" :class="{ selectable: report.selects }" @click="e => setAfpCol(getSelectKeys(report.selects))">
                <div class="report-title">{{ report.title }}</div>
                <div :style="{ width: '10px' }"></div>
                <img v-if="report.selects" :src="getSelectKeys(report.selects).some(key => afpCols.includes(key)) ? getSelectKeys(report.selects).every(key => afpCols.includes(key)) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-minus.svg') : require('../../assets/images/checkbox-false.svg')">
              </div>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div v-if="(report.optionGroups || []).length" class="report-option-container col-block">
              <div class="report-option-group row-block flex-start" v-for="(optionGroups, ogindex) in report.optionGroups" :key="ogindex">
                <div class="report-option-block row-block flex-wrap" v-for="(options, osindex) in optionGroups" :key="osindex" :style="(osindex + 1) === optionGroups.length ? { flex: 1 } : {}">
                  <div
                    class="report-option row-block"
                    :class="{ disabled: afpCols.length <= { 'db': 3, 'ps': 2 }[param.type] && afpCols.includes(option.key) }"
                    v-for="(option, oindex) in options.filter(option => (option.display || (() => true))(variants))"
                    :key="oindex"
                    @click="e => !(afpCols.length <= { 'db': 3, 'ps': 2 }[param.type] && afpCols.includes(option.key)) && setAfpCol([option.key])"
                  >
                    <img :src="afpCols.includes(option.key) ? require('../../assets/images/checkbox-true.svg') : require('../../assets/images/checkbox-false.svg')">
                    <div :style="{ width: '10px' }"></div>
                    <div class="report-option-title">{{ option.title }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="no-margin">
      <div :style="{ height: '15px' }"></div>
    </template>
    <div class="data-container col-block" v-for="(variant, vindex) in variants" :key="vindex">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-field col-block" :class="{ 'title-only': !afpDatas.some(afpData => afpData.title) }" v-for="([group, afpDatas], agindex) in Object.entries(afpDataGroups).filter(([group, afpDatas]) => afpDatas.some(afpData => (afpData.display || (() => true))(variant)))" :key="agindex">
        <template v-if="group && group !== 'undefined'">
          <div class="data-content-title">{{ groupTitleMap[group] || group }}</div>
        </template>
        <div v-if="afpDatas.some(afpData => afpData.title)" class="data-content-container row-block flex-wrap flex-start stretch">
          <div class="data-block-container col-block" :style="{ width: afpData.long ? '18.75%' : '12.5%' }" v-for="(afpData, aindex) in afpDatas.filter(afpData => (afpData.display || (() => true))(variant))" :key="aindex">
            <div class="data-block col-block" :style="{ flex: 1 }">
              <div :style="{ flex: 1 }"></div>
              <div class="data-content">{{ afpData.title }}</div>
              <div :style="{ flex: 1 }"></div>
            </div>
            <div class="data-block col-block" :class="[param.type]">
              <div :style="{ flex: 1 }"></div>
              <a v-if="afpData.link" class="data-link row-block" :href="afpData.link.url(variant)" target="_blank">
                <a class="link row-block shrink" v-html="afpData.link.title"></a>
                <div :style="{ width: '5px' }"></div>
                <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
              </a>
              <div v-else class="data-content ellipsis" :title="valueMap((afpData.hover || afpData.value)(variant))" :class="afpData.class(afpData.value(variant), variant)">{{ valueMap(afpData.value(variant)) }}</div>
              <div :style="{ flex: 1 }"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Return'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { putUserSettings } from '../../api'
import toastMethods from '../../mixins/toastMethods'
import { fixNumber, groupBy } from '../../constants/global/util'
import { predictionMetaDatas } from '../../constants/global/data'

export default {
  mixins: [
    toastMethods
  ],
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      afpCols: null,
      otherCols: null,
      display: {
        dbSelect: false
      },
      onSubmit: false
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'userSetting'
    ]),
    onError () {
      return !this.afpCols || this.afpCols.length < { 'db': 3, 'ps': 2 }[this.param.type]
    },
    afpDataGroups () {
      let afpCols = this.afpCols
      return groupBy(this.afpMap.filter(afp => afpCols.includes(afp.key) || !afp.key), data => data.group, true)
    },
    // param
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    // static
    groupTitleMap () {
      return {
        'Coverage gnomAD Exomes': 'gnomAD Exomes',
        'Coverage gnomAD Genomes': 'gnomAD Genomes'
      }
    },
    settingColumnData () {
      let group = {
        'SpliceAI': [
          'SpliceAI_DS_AL',
          'SpliceAI_DS_DG',
          'SpliceAI_DS_DL',
          'SpliceAI_DP_AG',
          'SpliceAI_DP_AL',
          'SpliceAI_DP_DG',
          'SpliceAI_DP_DL',
          'SpliceAI_DS_AG'
        ]
      }
      let map = Object.entries(group).reduce((map, [key, values]) => {
        let result = values.reduce((valueMap, value) => ({ ...valueMap, [value]: key }), {})
        return { ...map, ...result }
      }, {})
      return { group, map }
    },
    afpMap () {
      return [
        {
          title: 'AF'/* ___ */,
          key: 'KG_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.KG_AF,
          group: '1000 Genomes'/* ___ */
        },
        {
          title: 'EAS AF'/* ___ */,
          key: 'KG_EAS_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.KG_EAS_AF,
          group: '1000 Genomes'/* ___ */
        },
        {
          title: 'AMR AF'/* ___ */,
          key: 'KG_AMR_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.KG_AMR_AF,
          group: '1000 Genomes'/* ___ */
        },
        {
          title: 'AFR AF'/* ___ */,
          key: 'KG_AFR_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.KG_AFR_AF,
          group: '1000 Genomes'/* ___ */
        },
        {
          title: 'EUR AF'/* ___ */,
          key: 'KG_EUR_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.KG_EUR_AF,
          group: '1000 Genomes'/* ___ */
        },
        {
          title: 'SAS AF'/* ___ */,
          key: 'KG_SAS_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.KG_SAS_AF,
          group: '1000 Genomes'/* ___ */
        },
        {
          title: 'AF'/* ___ */,
          key: 'gnomAD_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_AF,
          group: 'gnomAD Exomes'/* ___ */
        },
        {
          title: 'AFR AF'/* ___ */,
          key: 'gnomAD_AFR_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_AFR_AF,
          group: 'gnomAD Exomes'/* ___ */
        },
        {
          title: 'AMR AF'/* ___ */,
          key: 'gnomAD_AMR_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_AMR_AF,
          group: 'gnomAD Exomes'/* ___ */
        },
        {
          title: 'ASJ AF'/* ___ */,
          key: 'gnomAD_ASJ_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_ASJ_AF,
          group: 'gnomAD Exomes'/* ___ */
        },
        {
          title: 'EAS AF'/* ___ */,
          key: 'gnomAD_EAS_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_EAS_AF,
          group: 'gnomAD Exomes'/* ___ */
        },
        {
          title: 'FIN AF'/* ___ */,
          key: 'gnomAD_FIN_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_FIN_AF,
          group: 'gnomAD Exomes'/* ___ */
        },
        {
          title: 'NFE AF'/* ___ */,
          key: 'gnomAD_NFE_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_NFE_AF,
          group: 'gnomAD Exomes'/* ___ */
        },
        {
          title: 'OTH AF'/* ___ */,
          key: 'gnomAD_OTH_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_OTH_AF,
          group: 'gnomAD Exomes'/* ___ */
        },
        {
          title: 'SAS AF'/* ___ */,
          key: 'gnomAD_SAS_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_SAS_AF,
          group: 'gnomAD Exomes'/* ___ */
        },
        {
          title: 'AF'/* ___ */,
          key: 'gnomAD_g_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'AFR AF'/* ___ */,
          key: 'gnomAD_g_AF_afr',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_afr,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'AMI AF'/* ___ */,
          key: 'gnomAD_g_AF_ami',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_ami,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'AMR AF'/* ___ */,
          key: 'gnomAD_g_AF_amr',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_amr,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'ASJ AF'/* ___ */,
          key: 'gnomAD_g_AF_asj',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_asj,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'EAS AF'/* ___ */,
          key: 'gnomAD_g_AF_eas',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_eas,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'FIN AF'/* ___ */,
          key: 'gnomAD_g_AF_fin',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_fin,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'MID AF'/* ___ */,
          key: 'gnomAD_g_AF_mid',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_mid,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'NFE AF'/* ___ */,
          key: 'gnomAD_g_AF_nfe',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_nfe,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'OTH AF'/* ___ */,
          key: 'gnomAD_g_AF_oth',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_oth,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'SAS AF'/* ___ */,
          key: 'gnomAD_g_AF_sas',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_AF_sas,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM !== 'chrM'
        },
        {
          title: 'Heteroplasmy AF'/* ___ */,
          key: 'gnomAD_g_mt_AF_het',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_AF_het,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy AFR AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_afr',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_afr,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy AMI AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_ami',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_ami,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy AMR AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_amr',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_amr,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy ASJ AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_asj',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_asj,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy EAS AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_eas',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_eas,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy FIN AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_fin',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_fin,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy MID AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_mid',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_mid,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy NFE AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_nfe',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_nfe,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy OTH AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_oth',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_oth,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Heteroplasmy SAS AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_het_sas',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_het_sas,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy AF'/* ___ */,
          key: 'gnomAD_g_mt_AF_hom',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_AF_hom,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy AFR AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_afr',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_afr,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy AMI AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_ami',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_ami,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy AMR AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_amr',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_amr,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy ASJ AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_asj',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_asj,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy EAS AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_eas',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_eas,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy FIN AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_fin',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_fin,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy MID AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_mid',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_mid,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy NFE AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_nfe',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_nfe,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy OTH AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_oth',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_oth,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Homoplasmy SAS AF'/* ___ */,
          key: 'gnomAD_g_mt_pop_AF_hom_sas',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.gnomAD_g_mt_pop_AF_hom_sas,
          group: 'gnomAD Genomes',
          display: variant => variant.CHROM === 'chrM'
        },
        {
          title: 'Filter'/* ___ */,
          key: 'PVDB_P_FILTER',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_P_FILTER,
          group: 'PhenoVarDB Private'
        },
        {
          title: 'Missing rate'/* ___ */,
          key: 'PVDB_P_F_MISSING',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_P_F_MISSING,
          group: 'PhenoVarDB Private'
        },
        {
          title: 'AC'/* ___ */,
          key: 'PVDB_P_AC',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_P_AC,
          group: 'PhenoVarDB Private'
        },
        {
          title: 'AN'/* ___ */,
          key: 'PVDB_P_AN',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_P_AN,
          group: 'PhenoVarDB Private'
        },
        {
          title: 'AF'/* ___ */,
          key: 'PVDB_P_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_P_AF,
          group: 'PhenoVarDB Private'
        },
        {
          title: 'DP'/* ___ */,
          key: 'PVDB_P_DP',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_P_DP,
          group: 'PhenoVarDB Private'
        },
        {
          title: 'AC in heterozygous genotypes'/* ___ */,
          key: 'PVDB_P_AC_Het',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_P_AC_Het,
          long: true,
          group: 'PhenoVarDB Private'
        },
        {
          title: 'AC in homozygous genotypes'/* ___ */,
          key: 'PVDB_P_AC_Hom',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_P_AC_Hom,
          long: true,
          group: 'PhenoVarDB Private'
        },
        {
          title: 'AC in hemizygous genotypes'/* ___ */,
          key: 'PVDB_P_AC_Hemi',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_P_AC_Hemi,
          long: true,
          group: 'PhenoVarDB Private'
        },
        {
          title: 'Filter'/* ___ */,
          key: 'PVDB_S_FILTER',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_S_FILTER,
          group: 'PhenoVarDB Community'
        },
        {
          title: 'Missing rate'/* ___ */,
          key: 'PVDB_S_F_MISSING',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_S_F_MISSING,
          group: 'PhenoVarDB Community'
        },
        {
          title: 'AC'/* ___ */,
          key: 'PVDB_S_AC',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_S_AC,
          group: 'PhenoVarDB Community'
        },
        {
          title: 'AN'/* ___ */,
          key: 'PVDB_S_AN',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_S_AN,
          group: 'PhenoVarDB Community'
        },
        {
          title: 'AF'/* ___ */,
          key: 'PVDB_S_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_S_AF,
          group: 'PhenoVarDB Community'
        },
        {
          title: 'DP'/* ___ */,
          key: 'PVDB_S_DP',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_S_DP,
          group: 'PhenoVarDB Community'
        },
        {
          title: 'AC in heterozygous genotypes'/* ___ */,
          key: 'PVDB_S_AC_Het',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_S_AC_Het,
          long: true,
          group: 'PhenoVarDB Community'
        },
        {
          title: 'AC in homozygous genotypes'/* ___ */,
          key: 'PVDB_S_AC_Hom',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_S_AC_Hom,
          long: true,
          group: 'PhenoVarDB Community'
        },
        {
          title: 'AC in hemizygous genotypes'/* ___ */,
          key: 'PVDB_S_AC_Hemi',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_S_AC_Hemi,
          long: true,
          group: 'PhenoVarDB Community'
        },
        {
          title: 'Filter'/* ___ */,
          key: 'PVDB_A_FILTER',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_A_FILTER,
          group: 'PhenoVarDB Admin',
          display: variant => ['supervisor'].includes(this.user.role)
        },
        {
          title: 'Missing rate'/* ___ */,
          key: 'PVDB_A_F_MISSING',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_A_F_MISSING,
          group: 'PhenoVarDB Admin',
          display: variant => ['supervisor'].includes(this.user.role)
        },
        {
          title: 'AC'/* ___ */,
          key: 'PVDB_A_AC',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_A_AC,
          group: 'PhenoVarDB Admin',
          display: variant => ['supervisor'].includes(this.user.role)
        },
        {
          title: 'AN'/* ___ */,
          key: 'PVDB_A_AN',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_A_AN,
          group: 'PhenoVarDB Admin',
          display: variant => ['supervisor'].includes(this.user.role)
        },
        {
          title: 'AF'/* ___ */,
          key: 'PVDB_A_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_A_AF,
          group: 'PhenoVarDB Admin',
          display: variant => ['supervisor'].includes(this.user.role)
        },
        {
          title: 'DP'/* ___ */,
          key: 'PVDB_A_DP',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_A_DP,
          group: 'PhenoVarDB Admin',
          display: variant => ['supervisor'].includes(this.user.role)
        },
        {
          title: 'AC in heterozygous genotypes'/* ___ */,
          key: 'PVDB_A_AC_Het',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_A_AC_Het,
          long: true,
          group: 'PhenoVarDB Admin',
          display: variant => ['supervisor'].includes(this.user.role)
        },
        {
          title: 'AC in homozygous genotypes'/* ___ */,
          key: 'PVDB_A_AC_Hom',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_A_AC_Hom,
          long: true,
          group: 'PhenoVarDB Admin',
          display: variant => ['supervisor'].includes(this.user.role)
        },
        {
          title: 'AC in hemizygous genotypes'/* ___ */,
          key: 'PVDB_A_AC_Hemi',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.PVDB_A_AC_Hemi,
          long: true,
          group: 'PhenoVarDB Admin',
          display: variant => ['supervisor'].includes(this.user.role)
        },
        {
          title: 'ESP6500'/* ___ */,
          key: 'ESP6500_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.ESP6500_AF,
          group: 'Other'/* ___ */
        },
        {
          title: 'ESP6500 AA'/* ___ */,
          key: 'ESP6500_AA_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.ESP6500_AA_AF,
          group: 'Other'/* ___ */
        },
        {
          title: 'ESP6500 AE'/* ___ */,
          key: 'ESP6500_EA_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.ESP6500_EA_AF,
          group: 'Other'/* ___ */
        },
        {
          title: 'Taiwan Biobank'/* ___ */,
          key: 'TW_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.TW_AF,
          group: 'Other'/* ___ */
        },
        {
          title: 'TOPMED'/* ___ */,
          key: 'TOPMED_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.TOPMED_AF,
          group: 'Other'/* ___ */
        },
        {
          title: 'UK10K'/* ___ */,
          key: 'UK10K_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.UK10K_AF,
          group: 'Other'/* ___ */
        },
        // {
        //   title: 'ChinaMAP'/* ___ */,
        //   key: 'ChinaMAP_AF',
        //   class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
        //   value: variant => variant.ChinaMAP_AF,
        //   group: 'Other'/* ___ */
        // },
        {
          title: 'Genome Asia100'/* ___ */,
          key: 'GA_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.GA_AF,
          group: 'Other'/* ___ */
        },
        // {
        //   title: '4.7KJPN'/* ___ */,
        //   key: 'KJ_AF',
        //   class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
        //   value: variant => variant.KJ_AF,
        //   group: 'Other'/* ___ */
        // },
        {
          title: 'ExAC'/* ___ */,
          key: 'ExAC_AF',
          class: value => (value || value === 0) ? value > 0.001 ? ['normal'] : ['alert'] : ['empty'],
          value: variant => variant.ExAC_AF,
          group: 'Other'/* ___ */
        },
        {
          group: 'Coverage',
          display: () => this.param.type === 'db'
        },
        {
          title: 'Mean'/* ___ */,
          key: 'gnomAD_cov_MEAN',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => variant.gnomAD_cov_MEAN,
          group: 'Coverage gnomAD Exomes'/* ___ */,
          groupFormat: title => title.replace(/^Coverage /, '')
        },
        {
          title: ' Median'/* ___ */,
          key: 'gnomAD_cov_MEDIAN',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => variant.gnomAD_cov_MEDIAN,
          group: 'Coverage gnomAD Exomes'/* ___ */,
          groupFormat: title => title.replace(/^Coverage /, '')
        },
        {
          title: '>20x coverage (%)'/* ___ */,
          key: 'gnomAD_cov_PCT_20X',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => variant.gnomAD_cov_PCT_20X,
          group: 'Coverage gnomAD Exomes'/* ___ */,
          groupFormat: title => title.replace(/^Coverage /, '')
        },
        {
          title: 'Mean'/* ___ */,
          key: 'gnomAD_g_cov_MEAN',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => variant.gnomAD_g_cov_MEAN,
          group: 'Coverage gnomAD Genomes'/* ___ */,
          groupFormat: title => title.replace(/^Coverage /, '')
        },
        {
          title: 'Median'/* ___ */,
          key: 'gnomAD_g_cov_MEDIAN',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => variant.gnomAD_g_cov_MEDIAN,
          group: 'Coverage gnomAD Genomes'/* ___ */,
          groupFormat: title => title.replace(/^Coverage /, '')
        },
        {
          title: '>20x coverage (%)'/* ___ */,
          key: 'gnomAD_g_cov_PCT_20X',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => variant.gnomAD_g_cov_PCT_20X,
          group: 'Coverage gnomAD Genomes'/* ___ */,
          groupFormat: title => title.replace(/^Coverage /, '')
        },
        {
          title: 'SIFT4G score'/* ___ */,
          key: 'SIFT4G_score',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SIFT4G'].checkPassed || (() => true))((variant.transcripts[variant.Feature] || {}).SIFT4G_score, (variant.transcripts[variant.Feature] || {}).SIFT4G_pred) + ''] || 'empty'],
          value: variant => (variant.transcripts[variant.Feature] || {}).SIFT4G_score
        },
        {
          title: 'SIFT4G pred'/* ___ */,
          key: 'SIFT4G_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['SIFT4G'].displayMap[(variant.transcripts[variant.Feature] || {}).SIFT4G_pred] || (variant.transcripts[variant.Feature] || {}).SIFT4G_pred
        },
        {
          title: 'Polyphen-2 HDIV'/* ___ */,
          key: 'Polyphen',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['Polyphen'].checkPassed || (() => true))((variant.transcripts[variant.Feature] || {}).Polyphen, (variant.transcripts[variant.Feature] || {}).Polyphen_pred) + ''] || 'empty'],
          value: variant => (variant.transcripts[variant.Feature] || {}).Polyphen
        },
        {
          title: 'Polyphen-2 HDIV pred'/* ___ */,
          key: 'Polyphen_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['Polyphen'].displayMap[(variant.transcripts[variant.Feature] || {}).Polyphen_pred] || (variant.transcripts[variant.Feature] || {}).Polyphen_pred
        },
        {
          title: 'FATHMM score'/* ___ */,
          key: 'FATHMM_score',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['FATHMM'].checkPassed || (() => true))((variant.transcripts[variant.Feature] || {}).FATHMM_score, (variant.transcripts[variant.Feature] || {}).FATHMM_pred) + ''] || 'empty'],
          value: variant => (variant.transcripts[variant.Feature] || {}).FATHMM_score
        },
        {
          title: 'FATHMM pred'/* ___ */,
          key: 'FATHMM_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['FATHMM'].displayMap[(variant.transcripts[variant.Feature] || {}).FATHMM_pred] || (variant.transcripts[variant.Feature] || {}).FATHMM_pred
        },
        {
          title: 'PROVEAN score'/* ___ */,
          key: 'PROVEAN_score',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['PROVEAN'].checkPassed || (() => true))((variant.transcripts[variant.Feature] || {}).PROVEAN_score, (variant.transcripts[variant.Feature] || {}).PROVEAN_pred) + ''] || 'empty'],
          value: variant => (variant.transcripts[variant.Feature] || {}).PROVEAN_score
        },
        {
          title: 'PROVEAN pred'/* ___ */,
          key: 'PROVEAN_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['PROVEAN'].displayMap[(variant.transcripts[variant.Feature] || {}).PROVEAN_pred] || (variant.transcripts[variant.Feature] || {}).PROVEAN_pred
        },
        {
          title: 'CADD phred'/* ___ */,
          key: 'CADD_phred',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['CADD_phred'].checkPassed || (() => true))(variant.CADD_phred, variant.CADD_phred_pred) + ''] || 'empty'],
          value: variant => variant.CADD_phred
        },
        {
          title: 'CADD phred pred'/* ___ */,
          key: 'CADD_phred_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['CADD_phred'].displayMap[variant.CADD_phred_pred] || variant.CADD_phred_pred
        },
        {
          title: 'MetaLR score'/* ___ */,
          key: 'MetaLR_score',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['MetaLR'].checkPassed || (() => true))(variant.MetaLR_score, variant.MetaLR_pred) + ''] || 'empty'],
          value: variant => variant.MetaLR_score
        },
        {
          title: 'MetaLR pred'/* ___ */,
          key: 'MetaLR_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['MetaLR'].displayMap[variant.MetaLR_pred] || variant.MetaLR_pred
        },
        {
          title: 'MetaSVM score'/* ___ */,
          key: 'MetaSVM_score',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['MetaSVM'].checkPassed || (() => true))(variant.MetaSVM_score, variant.MetaSVM_pred) + ''] || 'empty'],
          value: variant => variant.MetaSVM_score
        },
        {
          title: 'MetaSVM pred'/* ___ */,
          key: 'MetaSVM_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['MetaSVM'].displayMap[variant.MetaSVM_pred] || variant.MetaSVM_pred
        },
        // {
        //   title: 'REVEL score'/* ___ */,
        //   key: 'REVEL_score',
        //   class: (value, variant) => [{
        //     'true': 'normal',
        //     'false': 'alert'
        //   }[(predictionMetaDatas['REVEL'].checkPassed || (() => true))(variant.REVEL_score, variant.REVEL_pred) + ''] || 'empty'],
        //   value: variant => variant.REVEL_score
        // },
        // {
        //   title: 'REVEL pred'/* ___ */,
        //   key: 'REVEL_pred',
        //   class: value => (value || value === 0) ? ['normal'] : ['empty'],
        //   value: variant => predictionMetaDatas['REVEL'].displayMap[variant.REVEL_pred] || variant.REVEL_pred
        // },
        {
          title: 'BayesDel addAF score'/* ___ */,
          key: 'BayesDel_addAF_score',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['BayesDel_addAF'].checkPassed || (() => true))(variant.BayesDel_addAF_score, variant.BayesDel_addAF_pred) + ''] || 'empty'],
          value: variant => variant.BayesDel_addAF_score
        },
        {
          title: 'BayesDel addAF pred'/* ___ */,
          key: 'BayesDel_addAF_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['BayesDel_addAF'].displayMap[variant.BayesDel_addAF_pred] || variant.BayesDel_addAF_pred
        },
        {
          title: 'MitoTip score'/* ___ */,
          key: 'gnomAD_g_mt_mitotip_score',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['gnomAD_g_mt_mitotip'].checkPassed || (() => true))(variant.gnomAD_g_mt_mitotip_score, variant.gnomAD_g_mt_mitotip_score_pred) + ''] || 'empty'],
          value: variant => variant.gnomAD_g_mt_mitotip_score
        },
        {
          title: 'MitoTip pred'/* ___ */,
          key: 'gnomAD_g_mt_mitotip_score_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['gnomAD_g_mt_mitotip'].displayMap[variant.gnomAD_g_mt_mitotip_score_pred] || variant.gnomAD_g_mt_mitotip_score_pred
        },
        {
          title: 'ada score'/* ___ */,
          key: 'ada_score',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['ada'].checkPassed || (() => true))(variant.ada_score, variant.ada_pred) + ''] || 'empty'],
          value: variant => variant.ada_score
        },
        {
          title: 'ada pred'/* ___ */,
          key: 'ada_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['ada'].displayMap[variant.ada_pred] || variant.ada_pred
        },
        {
          title: 'rf score'/* ___ */,
          key: 'rf_score',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['rf'].checkPassed || (() => true))(variant.rf_score, variant.rf_pred) + ''] || 'empty'],
          value: variant => variant.rf_score
        },
        {
          title: 'rf pred'/* ___ */,
          key: 'rf_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['rf'].displayMap[variant.rf_pred] || variant.rf_pred
        },
        {
          title: 'SpliceAI'/* ___ */,
          key: 'SpliceAI',
          link: {
            title: 'Click here to look up SpliceAI scores'/* ___ */,
            url: variant => 'https://spliceailookup.broadinstitute.org/#variant=' + [variant.CHROM, variant.POS, variant.REF, variant.ALT].join('-') + '&hg=38&distance=50&mask=0&precomputed=1'
          },
          long: true
        },
        {
          title: 'SpliceAI\nAcceptor gain score'/* ___ */,
          key: 'SpliceAI_DS_AG',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SpliceAI_DS_AG'].checkPassed || (() => true))(variant.SpliceAI_DS_AG) + ''] || 'empty'],
          value: variant => variant.SpliceAI_DS_AG,
          long: true
        },
        {
          title: 'SpliceAI\nAcceptor loss score'/* ___ */,
          key: 'SpliceAI_DS_AL',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SpliceAI_DS_AL'].checkPassed || (() => true))(variant.SpliceAI_DS_AL) + ''] || 'empty'],
          value: variant => variant.SpliceAI_DS_AL,
          long: true
        },
        {
          title: 'SpliceAI\nDonor gain score'/* ___ */,
          key: 'SpliceAI_DS_DG',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SpliceAI_DS_DG'].checkPassed || (() => true))(variant.SpliceAI_DS_DG) + ''] || 'empty'],
          value: variant => variant.SpliceAI_DS_DG,
          long: true
        },
        {
          title: 'SpliceAI\nDonor loss score'/* ___ */,
          key: 'SpliceAI_DS_DL',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SpliceAI_DS_DL'].checkPassed || (() => true))(variant.SpliceAI_DS_DL) + ''] || 'empty'],
          value: variant => variant.SpliceAI_DS_DL,
          long: true
        },
        {
          title: 'SpliceAI\nAcceptor gain position'/* ___ */,
          key: 'SpliceAI_DP_AG',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SpliceAI_DP_AG'].checkPassed || (() => true))(variant.SpliceAI_DP_AG) + ''] || 'empty'],
          value: variant => variant.SpliceAI_DP_AG,
          long: true
        },
        {
          title: 'SpliceAI\nAcceptor loss position'/* ___ */,
          key: 'SpliceAI_DP_AL',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SpliceAI_DP_AL'].checkPassed || (() => true))(variant.SpliceAI_DP_AL) + ''] || 'empty'],
          value: variant => variant.SpliceAI_DP_AL,
          long: true
        },
        {
          title: 'SpliceAI\nDonor gain position'/* ___ */,
          key: 'SpliceAI_DP_DG',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SpliceAI_DP_DG'].checkPassed || (() => true))(variant.SpliceAI_DP_DG) + ''] || 'empty'],
          value: variant => variant.SpliceAI_DP_DG,
          long: true
        },
        {
          title: 'SpliceAI\nDonor loss positon'/* ___ */,
          key: 'SpliceAI_DP_DL',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SpliceAI_DP_DL'].checkPassed || (() => true))(variant.SpliceAI_DP_DL) + ''] || 'empty'],
          value: variant => variant.SpliceAI_DP_DL,
          long: true
        },
        {
          title: 'GERP++NR'/* ___ */,
          key: 'GERPpp_NR',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['GERPpp_NR'].checkPassed || (() => true))(variant.GERPpp_NR) + ''] || 'empty'],
          value: variant => variant.GERPpp_NR
        },
        {
          title: 'GERP++RS'/* ___ */,
          key: 'GERPpp_RS',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['GERPpp_RS'].checkPassed || (() => true))(variant.GERPpp_RS, variant.GERPpp_RS_pred) + ''] || 'empty'],
          value: variant => variant.GERPpp_RS
        },
        {
          title: 'GERPpp RS pred'/* ___ */,
          key: 'GERPpp_RS_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['GERPpp_RS'].displayMap[variant.GERPpp_RS_pred] || variant.GERPpp_RS_pred
        },
        {
          title: 'SiPhy 29way logOdds'/* ___ */,
          key: 'SiPhy_29way_logOdds',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SiPhy_29way_logOdds'].checkPassed || (() => true))(variant.SiPhy_29way_logOdds, variant.SiPhy_29way_logOdds_pred) + ''] || 'empty'],
          value: variant => variant.SiPhy_29way_logOdds
        },
        {
          title: 'SiPhy 29way logOdds pred'/* ___ */,
          key: 'SiPhy_29way_logOdds_pred',
          class: value => (value || value === 0) ? ['normal'] : ['empty'],
          value: variant => predictionMetaDatas['SiPhy_29way_logOdds'].displayMap[variant.SiPhy_29way_logOdds_pred] || variant.SiPhy_29way_logOdds_pred
        },
        {
          title: 'SiPhy 29way pi'/* ___ */,
          key: 'SiPhy_29way_pi',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['SiPhy_29way_pi'].checkPassed || (() => true))(variant.SiPhy_29way_pi) + ''] || 'empty'],
          value: variant => variant.SiPhy_29way_pi ? variant.SiPhy_29way_pi.split(':').map(v => (fixNumber(v, 0.01) + '').replace(/^0$/, '0.0')).join(':') : variant.SiPhy_29way_pi,
          hover: variant => variant.SiPhy_29way_pi
        },
        {
          title: 'Synonymous\no/e'/* ___ */,
          key: 'oe_syn',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['oe_syn'].checkPassed || (() => true))(this.gene.oe_syn) + ''] || 'empty'],
          value: () => this.gene.oe_syn
        },
        {
          title: 'Missense\no/e'/* ___ */,
          key: 'oe_mis',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['oe_mis'].checkPassed || (() => true))(this.gene.oe_mis) + ''] || 'empty'],
          value: () => this.gene.oe_mis
        },
        {
          title: 'pLoF\no/e'/* ___ */,
          key: 'oe_lof',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['oe_lof'].checkPassed || (() => true))(this.gene.oe_lof) + ''] || 'empty'],
          value: () => this.gene.oe_lof
        },
        {
          title: 'Synonymous\nz-score'/* ___ */,
          key: 'syn_z',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['syn_z'].checkPassed || (() => true))(this.gene.syn_z) + ''] || 'empty'],
          value: () => this.gene.syn_z
        },
        {
          title: 'Missense\nz-score'/* ___ */,
          key: 'mis_z',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['mis_z'].checkPassed || (() => true))(this.gene.mis_z) + ''] || 'empty'],
          value: () => this.gene.mis_z
        },
        {
          title: 'pLI'/* ___ */,
          key: 'pLI',
          class: (value, variant) => [{
            'true': 'normal',
            'false': 'alert'
          }[(predictionMetaDatas['pLI'].checkPassed || (() => true))(this.gene.pLI) + ''] || 'empty'],
          value: () => this.gene.pLI
        }
      ]
    },
    dbOptionGroups () {
      return [
        {
          title: 'Allele Frequency'/* ___ */,
          value: 'AF',
          selects: ['AF 1000 Genomes', 'AF gnomAD Exomes', 'AF gnomAD Genomes', 'AF PhenoVarDB Private', 'AF PhenoVarDB Community', 'AF PhenoVarDB Admin', 'AF Other']
        },
        {
          title: '1000 Genomes'/* ___ */,
          value: 'AF 1000 Genomes',
          optionGroups: [
            [
              [
                {
                  title: 'AF'/* ___ */,
                  key: 'KG_AF'
                },
                {
                  title: 'EAS AF'/* ___ */,
                  key: 'KG_EAS_AF'
                },
                {
                  title: 'AMR AF'/* ___ */,
                  key: 'KG_AMR_AF'
                },
                {
                  title: 'AFR AF'/* ___ */,
                  key: 'KG_AFR_AF'
                },
                {
                  title: 'EUR AF'/* ___ */,
                  key: 'KG_EUR_AF'
                },
                {
                  title: 'SAS AF'/* ___ */,
                  key: 'KG_SAS_AF'
                }
              ]
            ]
          ]
        },
        {
          title: 'gnomAD Exomes'/* ___ */,
          value: 'AF gnomAD Exomes',
          optionGroups: [
            [
              [
                {
                  title: 'AF'/* ___ */,
                  key: 'gnomAD_AF'
                },
                {
                  title: 'AFR AF'/* ___ */,
                  key: 'gnomAD_AFR_AF'
                },
                {
                  title: 'AMR AF'/* ___ */,
                  key: 'gnomAD_AMR_AF'
                },
                {
                  title: 'ASJ AF'/* ___ */,
                  key: 'gnomAD_ASJ_AF'
                },
                {
                  title: 'EAS AF'/* ___ */,
                  key: 'gnomAD_EAS_AF'
                },
                {
                  title: 'FIN AF'/* ___ */,
                  key: 'gnomAD_FIN_AF'
                },
                {
                  title: 'NFE AF'/* ___ */,
                  key: 'gnomAD_NFE_AF'
                },
                {
                  title: 'OTH AF'/* ___ */,
                  key: 'gnomAD_OTH_AF'
                },
                {
                  title: 'SAS AF'/* ___ */,
                  key: 'gnomAD_SAS_AF'
                }
              ]
            ]
          ]
        },
        {
          title: 'gnomAD Genomes'/* ___ */,
          value: 'AF gnomAD Genomes',
          optionGroups: [
            [
              [
                {
                  title: 'AF'/* ___ */,
                  key: 'gnomAD_g_AF',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'AFR AF'/* ___ */,
                  key: 'gnomAD_g_AF_afr',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'AMI AF'/* ___ */,
                  key: 'gnomAD_g_AF_ami',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'AMR AF'/* ___ */,
                  key: 'gnomAD_g_AF_amr',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'ASJ AF'/* ___ */,
                  key: 'gnomAD_g_AF_asj',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'EAS AF'/* ___ */,
                  key: 'gnomAD_g_AF_eas',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'FIN AF'/* ___ */,
                  key: 'gnomAD_g_AF_fin',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'MID AF'/* ___ */,
                  key: 'gnomAD_g_AF_mid',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'NFE AF'/* ___ */,
                  key: 'gnomAD_g_AF_nfe',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'OTH AF'/* ___ */,
                  key: 'gnomAD_g_AF_oth',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'SAS AF'/* ___ */,
                  key: 'gnomAD_g_AF_sas',
                  display: variants => Object.values(variants).some(variant => variant.CHROM !== 'chrM')
                },
                {
                  title: 'Heteroplasmy AF'/* ___ */,
                  key: 'gnomAD_g_mt_AF_het',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy AFR AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_afr',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy AMI AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_ami',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy AMR AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_amr',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy ASJ AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_asj',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy EAS AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_eas',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy FIN AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_fin',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy MID AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_mid',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy NFE AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_nfe',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy OTH AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_oth',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Heteroplasmy SAS AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_het_sas',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy AF'/* ___ */,
                  key: 'gnomAD_g_mt_AF_hom',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy AFR AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_afr',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy AMI AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_ami',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy AMR AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_amr',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy ASJ AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_asj',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy EAS AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_eas',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy FIN AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_fin',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy MID AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_mid',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy NFE AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_nfe',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy OTH AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_oth',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                },
                {
                  title: 'Homoplasmy SAS AF'/* ___ */,
                  key: 'gnomAD_g_mt_pop_AF_hom_sas',
                  display: variants => Object.values(variants).some(variant => variant.CHROM === 'chrM')
                }
              ]
            ]
          ]
        },
        {
          title: 'PhenoVarDB Private'/* ___ */,
          value: 'AF PhenoVarDB Private',
          optionGroups: [
            [
              [
                {
                  title: 'Filter'/* ___ */,
                  key: 'PVDB_P_FILTER'
                },
                {
                  title: 'Missing rate'/* ___ */,
                  key: 'PVDB_P_F_MISSING'
                },
                {
                  title: 'AC'/* ___ */,
                  key: 'PVDB_P_AC'
                },
                {
                  title: 'AN'/* ___ */,
                  key: 'PVDB_P_AN'
                },
                {
                  title: 'AF'/* ___ */,
                  key: 'PVDB_P_AF'
                },
                {
                  title: 'DP'/* ___ */,
                  key: 'PVDB_P_DP'
                },
                {
                  title: 'AC in heterozygous genotypes'/* ___ */,
                  key: 'PVDB_P_AC_Het'
                },
                {
                  title: 'AC in homozygous genotypes'/* ___ */,
                  key: 'PVDB_P_AC_Hom'
                },
                {
                  title: 'AC in hemizygous genotypes'/* ___ */,
                  key: 'PVDB_P_AC_Hemi'
                }
              ]
            ]
          ]
        },
        {
          title: 'PhenoVarDB Community'/* ___ */,
          value: 'AF PhenoVarDB Community',
          optionGroups: [
            [
              [
                {
                  title: 'Filter'/* ___ */,
                  key: 'PVDB_S_FILTER'
                },
                {
                  title: 'Missing rate'/* ___ */,
                  key: 'PVDB_S_F_MISSING'
                },
                {
                  title: 'AC'/* ___ */,
                  key: 'PVDB_S_AC'
                },
                {
                  title: 'AN'/* ___ */,
                  key: 'PVDB_S_AN'
                },
                {
                  title: 'AF'/* ___ */,
                  key: 'PVDB_S_AF'
                },
                {
                  title: 'DP'/* ___ */,
                  key: 'PVDB_S_DP'
                },
                {
                  title: 'AC in heterozygous genotypes'/* ___ */,
                  key: 'PVDB_S_AC_Het'
                },
                {
                  title: 'AC in homozygous genotypes'/* ___ */,
                  key: 'PVDB_S_AC_Hom'
                },
                {
                  title: 'AC in hemizygous genotypes'/* ___ */,
                  key: 'PVDB_S_AC_Hemi'
                }
              ]
            ]
          ]
        },
        {
          title: 'PhenoVarDB Admin'/* ___ */,
          value: 'AF PhenoVarDB Admin',
          display: variants => ['supervisor'].includes(this.user.role),
          optionGroups: [
            [
              [
                {
                  title: 'Filter'/* ___ */,
                  key: 'PVDB_A_FILTER'
                },
                {
                  title: 'Missing rate'/* ___ */,
                  key: 'PVDB_A_F_MISSING'
                },
                {
                  title: 'AC'/* ___ */,
                  key: 'PVDB_A_AC'
                },
                {
                  title: 'AN'/* ___ */,
                  key: 'PVDB_A_AN'
                },
                {
                  title: 'AF'/* ___ */,
                  key: 'PVDB_A_AF'
                },
                {
                  title: 'DP'/* ___ */,
                  key: 'PVDB_A_DP'
                },
                {
                  title: 'AC in heterozygous genotypes'/* ___ */,
                  key: 'PVDB_A_AC_Het'
                },
                {
                  title: 'AC in homozygous genotypes'/* ___ */,
                  key: 'PVDB_A_AC_Hom'
                },
                {
                  title: 'AC in hemizygous genotypes'/* ___ */,
                  key: 'PVDB_A_AC_Hemi'
                }
              ]
            ]
          ]
        },
        {
          title: 'Other'/* ___ */,
          value: 'AF Other',
          optionGroups: [
            [
              [
                {
                  title: 'ESP6500'/* ___ */,
                  key: 'ESP6500_AF'
                },
                {
                  title: 'ESP6500 AA'/* ___ */,
                  key: 'ESP6500_AA_AF'
                },
                {
                  title: 'ESP6500 AE'/* ___ */,
                  key: 'ESP6500_EA_AF'
                }
              ]
            ],
            [
              [
                {
                  title: 'Taiwan Biobank'/* ___ */,
                  key: 'TW_AF'
                },
                {
                  title: 'TOPMED'/* ___ */,
                  key: 'TOPMED_AF'
                },
                {
                  title: 'UK10K'/* ___ */,
                  key: 'UK10K_AF'
                },
                // {
                //   title: 'ChinaMAP'/* ___ */,
                //   key: 'ChinaMAP_AF'
                // },
                {
                  title: 'Genome Asia100'/* ___ */,
                  key: 'GA_AF'
                }
                // {
                //   title: '4.7KJPN'/* ___ */,
                //   key: 'KJ_AF'
                // }
              ]
            ],
            [
              [
                {
                  title: 'ExAC'/* ___ */,
                  key: 'ExAC_AF'
                }
              ]
            ]
          ]
        },
        {
          title: 'Coverage'/* ___ */,
          value: 'Coverage'/* ___ */,
          selects: ['Coverage gnomAD Exomes', 'Coverage gnomAD Genomes']
        },
        {
          title: 'gnomAD Exomes'/* ___ */,
          value: 'Coverage gnomAD Exomes',
          optionGroups: [
            [
              [
                {
                  title: 'Mean'/* ___ */,
                  key: 'gnomAD_cov_MEAN'
                },
                {
                  title: ' Median'/* ___ */,
                  key: 'gnomAD_cov_MEDIAN'
                },
                {
                  title: '>20x coverage (%)'/* ___ */,
                  key: 'gnomAD_cov_PCT_20X'
                }
              ]
            ]
          ]
        },
        {
          title: 'gnomAD Genomes'/* ___ */,
          value: 'Coverage gnomAD Genomes',
          optionGroups: [
            [
              [
                {
                  title: 'Mean'/* ___ */,
                  key: 'gnomAD_g_cov_MEAN'
                },
                {
                  title: ' Median'/* ___ */,
                  key: 'gnomAD_g_cov_MEDIAN'
                },
                {
                  title: '>20x coverage (%)'/* ___ */,
                  key: 'gnomAD_g_cov_PCT_20X'
                }
              ]
            ]
          ]
        }
      ]
    },
    psOptionGroups () {
      return [
        {
          title: 'Prediction Scores - Function Prediction'/* ___ */,
          value: 'Prediction Scores - Function Prediction',
          selects: ['Prediction Scores - Function Prediction'],
          optionGroups: [
            [
              [
                {
                  title: 'SIFT4G score'/* ___ */,
                  key: 'SIFT4G_score'
                },
                {
                  title: 'SIFT4G pred'/* ___ */,
                  key: 'SIFT4G_pred'
                },
                {
                  title: 'Polyphen-2 HDIV'/* ___ */,
                  key: 'Polyphen'
                },
                {
                  title: 'Polyphen-2 HDIV pred'/* ___ */,
                  key: 'Polyphen_pred'
                },
                {
                  title: 'FATHMM score'/* ___ */,
                  key: 'FATHMM_score'
                },
                {
                  title: 'FATHMM pred'/* ___ */,
                  key: 'FATHMM_pred'
                },
                {
                  title: 'PROVEAN score'/* ___ */,
                  key: 'PROVEAN_score'
                },
                {
                  title: 'PROVEAN pred'/* ___ */,
                  key: 'PROVEAN_pred'
                },
                {
                  title: 'CADD phred'/* ___ */,
                  key: 'CADD_phred'
                },
                {
                  title: 'CADD phred pred'/* ___ */,
                  key: 'CADD_phred_pred'
                },
                {
                  title: 'MetaLR score'/* ___ */,
                  key: 'MetaLR_score'
                },
                {
                  title: 'MetaLR pred'/* ___ */,
                  key: 'MetaLR_pred'
                },
                {
                  title: 'MetaSVM score'/* ___ */,
                  key: 'MetaSVM_score'
                },
                {
                  title: 'MetaSVM pred'/* ___ */,
                  key: 'MetaSVM_pred'
                },
                // {
                //   title: 'REVEL score'/* ___ */,
                //   key: 'REVEL_score'
                // },
                // {
                //   title: 'REVEL pred'/* ___ */,
                //   key: 'REVEL_pred'
                // },
                {
                  title: 'BayesDel addAF score'/* ___ */,
                  key: 'BayesDel_addAF_score'
                },
                {
                  title: 'BayesDel addAF red'/* ___ */,
                  key: 'BayesDel_addAF_pred'
                },
                {
                  title: 'MitoTip score'/* ___ */,
                  key: 'gnomAD_g_mt_mitotip_score'
                },
                {
                  title: 'MitoTip pred'/* ___ */,
                  key: 'gnomAD_g_mt_mitotip_score_pred'
                }
              ]
            ]
          ]
        },
        {
          title: 'Prediction Scores - Splice Site'/* ___ */,
          value: 'Prediction Scores - Splice Site',
          selects: ['Prediction Scores - Splice Site'],
          optionGroups: [
            [
              [
                {
                  title: 'ada score'/* ___ */,
                  key: 'ada_score'
                },
                {
                  title: 'ada pred'/* ___ */,
                  key: 'ada_pred'
                },
                {
                  title: 'rf score'/* ___ */,
                  key: 'rf_score'
                },
                {
                  title: 'rf pred'/* ___ */,
                  key: 'rf_pred'
                },
                {
                  title: 'SpliceAI'/* ___ */,
                  key: 'SpliceAI'
                }
                // {
                //   title: 'SpliceAI Acceptor gain score'/* ___ */,
                //   key: 'SpliceAI_DS_AG'
                // },
                // {
                //   title: 'SpliceAI Acceptor loss score'/* ___ */,
                //   key: 'SpliceAI_DS_AL'
                // },
                // {
                //   title: 'SpliceAI Donor gain score'/* ___ */,
                //   key: 'SpliceAI_DS_DG'
                // },
                // {
                //   title: 'SpliceAI Donor loss score'/* ___ */,
                //   key: 'SpliceAI_DS_DL'
                // },
                // {
                //   title: 'SpliceAI Acceptor gain position'/* ___ */,
                //   key: 'SpliceAI_DP_AG'
                // },
                // {
                //   title: 'SpliceAI Acceptor loss position'/* ___ */,
                //   key: 'SpliceAI_DP_AL'
                // },
                // {
                //   title: 'SpliceAI Donor gain position'/* ___ */,
                //   key: 'SpliceAI_DP_DG'
                // },
                // {
                //   title: 'SpliceAI Donor loss positon'/* ___ */,
                //   key: 'SpliceAI_DP_DL'
                // }
              ]
            ]
          ]
        },
        {
          title: 'Prediction Scores - Conservation'/* ___ */,
          value: 'Prediction Scores - Conservation',
          selects: ['Prediction Scores - Conservation'],
          optionGroups: [
            [
              [
                {
                  title: 'GERP++NR'/* ___ */,
                  key: 'GERPpp_NR'
                },
                {
                  title: 'GERP++RS'/* ___ */,
                  key: 'GERPpp_RS'
                },
                {
                  title: 'GERP++RS pred'/* ___ */,
                  key: 'GERPpp_RS_pred'
                },
                {
                  title: 'SiPhy 29way logOdds'/* ___ */,
                  key: 'SiPhy_29way_logOdds'
                },
                {
                  title: 'SiPhy 29way logOdds pred'/* ___ */,
                  key: 'SiPhy_29way_logOdds_pred'
                },
                {
                  title: 'SiPhy 29way pi'/* ___ */,
                  key: 'SiPhy_29way_pi'
                }
              ]
            ]
          ]
        },
        {
          title: 'Prediction Scores - gnomAD Constraint'/* ___ */,
          value: 'Prediction Scores - gnomAD Constraint',
          selects: ['Prediction Scores - gnomAD Constraint'],
          optionGroups: [
            [
              [
                {
                  title: 'Synonymous o/e'/* ___ */,
                  key: 'oe_syn'
                },
                {
                  title: 'Missense o/e'/* ___ */,
                  key: 'oe_mis'
                },
                {
                  title: 'pLoF o/e'/* ___ */,
                  key: 'oe_lof'
                },
                {
                  title: 'Synonymous z-score'/* ___ */,
                  key: 'syn_z'
                },
                {
                  title: 'Missense z-score'/* ___ */,
                  key: 'mis_z'
                },
                {
                  title: 'pLI'/* ___ */,
                  key: 'pLI'
                }
              ]
            ]
          ]
        }
      ]
    },
    reportOptionGroups () {
      return [
        ...(['db'].includes(this.param.type) ? [this.dbOptionGroups] : []),
        ...(['ps'].includes(this.param.type) ? [this.psOptionGroups] : [])
      ]
    }
  },
  created () {
    const colMap = reportGroups => {
      let result = reportGroups
      result = Array.prototype.concat.apply([], result.map(reportGroup => reportGroup.optionGroups || []))
      result = Array.prototype.concat.apply([], result)
      result = Array.prototype.concat.apply([], result)
      result = result.map(x => x.key)
      return result
    }
    let settingColumns = Object.keys(this.userSetting.report_preview_af_columns.reduce((result, column) => ({ ...result, [this.settingColumnData['map'][column] || column]: true }), {}))
    let cols = {
      'db': colMap(this.dbOptionGroups),
      'ps': colMap(this.psOptionGroups)
    }
    let afpCols = settingColumns.filter(col => cols[this.param.type].includes(col))
    afpCols = afpCols && afpCols.length ? afpCols : {
      'db': [
        'KG_EAS_AF',
        'gnomAD_EAS_AF',
        'TW_AF'
      ],
      'ps': [
        'SIFT4G_score',
        'Polyphen'
      ]
    }[this.param.type]
    delete cols[this.param.type]
    cols = Array.prototype.concat.apply([], Object.values(cols))
    let otherCols = settingColumns.filter(col => cols.includes(col))
    this.afpCols = afpCols
    this.otherCols = otherCols
  },
  methods: {
    ...mapActions([
      'setUserSettingAction'
    ]),
    valueMap (value) {
      return (value || value === 0) ? value : (value === null || value === '') ? 'N/A' : '?'
    },
    getSelectKeys (selects) {
      let optionMap = this.reportOptionGroups[0].reduce((map, option) => ({ ...map, [option.value]: option }), {})
      return Array.prototype.concat.apply([], selects.map(select => {
        return Array.prototype.concat.apply([], optionMap[select].optionGroups.map(optionGroup => {
          return Array.prototype.concat.apply([], optionGroup.map(options => options.map(option => option.key)))
        }))
      }))
    },
    async setAfpCol (keys) {
      let afpCols = [...this.afpCols]
      afpCols = afpCols.filter(col => !keys.includes(col))
      if (this.afpCols.length === afpCols.length) {
        afpCols = afpCols.concat(keys)
      }
      this.afpCols = afpCols
      await this.editUserSetting()
    },
    async editUserSetting () {
      this.onSubmit = true
      try {
        let config = this.$ls.get('userInfo')
        let selectedColumns = [
          ...this.afpCols,
          ...this.otherCols
        ]
        selectedColumns = Array.prototype.concat.apply([], selectedColumns.map(column => this.settingColumnData['group'][column] || [column]))
        let data = {
          report_preview_af_columns: selectedColumns
        }
        let response = await putUserSettings(data, config)
        let userSettings = response.data.data
        this.setUserSettingAction(userSettings)
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
      this.onSubmit = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGeneUserSetting.vue